import * as types from '../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";

export function loadGalleryImageSuccess(galleryImage) {
    return {type: types.GET_GALLERY_IMAGE_SUCCESS, galleryImage};
}

export function createGalleryImageSuccess(galleryImage) {
    return {type: types.CREATE_GALLERY_IMAGE_SUCCESS, galleryImage};
}

export function updateGalleryImageSuccess(galleryImage) {
    return {type: types.UPDATE_GALLERY_IMAGE_SUCCESS, galleryImage};
}

export function deleteGalleryImageSuccess(id) {
    return {type: types.DELETE_GALLERY_IMAGE_SUCCESS, id};
}

export function resetGalleryImage() {
    return {type: types.RESET_GALLERY_IMAGE };
}

export function loadGalleryImagesSuccess(galleryImages) {
    return {type: types.GET_GALLERY_IMAGES_SUCCESS, galleryImages}
}

export function loadGalleryImage(galleryId, imageId) {
    return function (dispatch) {
        return PrivateAPIResource.get(`gallery/image/${galleryId}/${imageId}`).then(galleryImage => {
            dispatch(loadGalleryImageSuccess(galleryImage))
        }).catch(error => {
            throw error;
        });
    }
}

export function createGalleryImage(galleryImageData) {
    return function (dispatch, getState) {
        return PrivateAPIResource
            .create(`gallery/add-image/${galleryImageData.galleryId}`, galleryImageData, true)
            .then(galleryImage => {
                dispatch(createGalleryImageSuccess(galleryImage));
            }).catch(error => {
                throw error;
            })
    }
}

export function updateGalleryImage(galleryImage, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource
            .update(`gallery/update-image/${galleryImage.galleryId}`, id, galleryImage, true)
            .then(galleryImage => {
                dispatch(updateGalleryImageSuccess(galleryImage));
            }).catch(error => {
                throw error;
            })
    }
}

export function deleteGalleryImage(galleryId, imageId) {
    return function (dispatch) {
        return PrivateAPIResource.remove(`gallery/remove-image/${galleryId}`, imageId).then(galleryImage => {
            dispatch(deleteGalleryImageSuccess(imageId))
        }).catch(error => {
            throw error;
        });
    }
}

export function loadGalleryImages(galleryId) {
    return function (dispatch, getState) {
        return PrivateAPIResource
            .get(`gallery/images/${galleryId}`)
            .then(galleryImages => {
                dispatch(loadGalleryImagesSuccess(galleryImages));
            })
            .catch(error => {
                throw error;
            })
    }
}

export function swapGalleryImages(indexA, indexB, galleryImages) {
    return {type: types.SWAP_GALLERY_IMAGES, indexA, indexB, galleryImages};
}

export function reorderGalleryImages(galleryId, galleryImagesIds) {
    return function (dispatch, getState) {
        return PrivateAPIResource
            .put(`gallery/reorder-images/${galleryId}`, {
                imageIds: galleryImagesIds
            })
            .then(galleryImages => {
                dispatch(loadGalleryImages(galleryId));
            })
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/gallery/galleryImageActions.js